import templateUrl from 'emun.order/parts/parts-order-header-fieldset.htm'
import 'emun.order/parts/parts-order-header-fieldset.retailers.htm'
import controller from 'emun.order/parts/parts-order-header-fieldset.controller'

export default {
    bindings: {
        order: '<',
        showVendor: '@',
        onCreateContact: '&'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}